module.exports = __webpack_public_path__ + "img/musah.5c1f4cd4.jpg";